import { render } from "./TheSettings.vue?vue&type=template&id=2b8aad90&scoped=true"
import script from "./TheSettings.vue?vue&type=script&lang=js"
export * from "./TheSettings.vue?vue&type=script&lang=js"

import "./TheSettings.vue?vue&type=style&index=0&id=2b8aad90&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8aad90"]])

export default __exports__